export default __webpack_public_path__ + "static/media/gilroy-regular.eed0ee63.svg";